module.exports = __webpack_public_path__ + "static/media/tv.cb5dd960.svg";